// extracted by mini-css-extract-plugin
export default {"assessment":"assessment_assessment__VGB-t","imgWrapper":"assessment_imgWrapper__0fu2Q","btnRemove":"assessment_btnRemove__fI82o"};